module.exports = __webpack_public_path__ + "img/zhonghua.7a5e836a.png";